import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import ApiClient from "../../methods/api/apiClient";
import { isGuestMode } from "../../methods/guestMode";

const KEY = "anyhomes_dormant_invite";

/**
 * Après inscription/connexion, si un lien d'activation pro dormant a été ouvert
 * (token stocké en localStorage), on rattache automatiquement les biens du
 * dormant au compte qui vient d'être créé.
 */
const DormantInviteClaimer = () => {
  const user = useSelector((s) => s.user);
  const done = useRef(false);
  const isConnected = !!user?.loggedIn && !user?.isGuest && !isGuestMode();

  useEffect(() => {
    if (!isConnected || done.current) return;
    const token = typeof window !== "undefined" ? localStorage.getItem(KEY) : null;
    if (!token) return;
    done.current = true;
    ApiClient.post(`api/invite/dormant/accept/${token}`, {})
      .then((res) => {
        if (res?.success) localStorage.removeItem(KEY);
      })
      .catch(() => {});
  }, [isConnected]);

  return null;
};

export default DormantInviteClaimer;
